import type { AdminSessionExitAction } from '@playcastdotio/Messaging';

/** Resolves explicit admin exits while preserving the session's existing fallback. */
export class AdminSessionExitPolicy {
  private static readonly ACTIONS: readonly AdminSessionExitAction[] = [
    'reboot', 'restart_game', 'keep_game', 'exit_nonsole',
  ];

  public static parse(message: { exitAction?: unknown; reboot?: unknown },
    fallback: AdminSessionExitAction = 'exit_nonsole'): AdminSessionExitAction {
    if (typeof message.exitAction === 'string'
      && AdminSessionExitPolicy.ACTIONS.includes(message.exitAction as AdminSessionExitAction)) {
      return message.exitAction as AdminSessionExitAction;
    }
    return message.reboot === true ? 'reboot' : fallback;
  }
}
